import React from 'react';
import { ReservationFilters, ReservationSource, ReservationStatus } from '@/domain/entities';

interface ReservationsFiltersProps {
  filters: ReservationFilters;
  sources: ReservationSource[];
  onChange: (filters: ReservationFilters) => void;
  onReset: () => void;
}

const STATUSES: { value: ReservationStatus; label: string }[] = [
  { value: 'active', label: 'Активные' },
  { value: 'completed', label: 'Завершенные' },
  { value: 'cancelled', label: 'Отмененные' },
];

export const ReservationsFilters: React.FC<ReservationsFiltersProps> = ({
  filters,
  sources,
  onChange,
  onReset,
}) => {
  const [searchSku, setSearchSku] = React.useState(filters.sku || '');

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onChange({
      ...filters,
      sku: searchSku.trim() || undefined,
    });
  };

  const handleStatusChange = (value: string) => {
    onChange({
      ...filters,
      status: value ? (value as ReservationStatus) : undefined,
    });
  };

  const handleSourceChange = (value: string) => {
    onChange({
      ...filters,
      sourceId: value ? parseInt(value) : undefined,
    });
  };

  const handleReset = () => {
    setSearchSku('');
    onReset();
  };

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-4">
      <form onSubmit={handleSearchSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {/* Статус */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Статус
            </label>
            <select
              value={filters.status || ''}
              onChange={(e) => handleStatusChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400"
            >
              <option value="">Все статусы</option>
              {STATUSES.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </select>
          </div>

          {/* Источник */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Источник
            </label>
            <select
              value={filters.sourceId || ''}
              onChange={(e) => handleSourceChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400"
            >
              <option value="">Все источники</option>
              {sources.map((source) => (
                <option key={source.id} value={source.id}>
                  {source.name}
                </option>
              ))}
            </select>
          </div>

          {/* Поиск по SKU */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Поиск по SKU
            </label>
            <input
              type="text"
              value={searchSku}
              onChange={(e) => setSearchSku(e.target.value)}
              placeholder="Введите SKU..."
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400"
            />
          </div>

          {/* Кнопки */}
          <div className="flex items-end gap-2">
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors font-medium"
            >
              Применить
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors font-medium"
            >
              Сбросить
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

